module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Previous transactions from the same account"},"et":{"title":"Previous transactions from the same account"},"ru":{"title":"Previous transactions from the same account"}}')
  delete Component.options._Ctor
}
